import * as React from 'react'
import { Redirect, RouteComponentProps, withRouter } from 'react-router'
import {
  buildFleetNativePanelRoute,
  getFleetPanelFromSearch,
} from '../services/fleet-navigation'

const FleetTrackerPageInner: React.FC<RouteComponentProps> = ({ location }) => {
  const panel = getFleetPanelFromSearch(location.search)
  return React.createElement(Redirect as any, {
    to: buildFleetNativePanelRoute(panel, location.search, location.pathname),
  })
}

export const FleetTrackerPage = withRouter(FleetTrackerPageInner as any) as React.ComponentType<{}>

export default FleetTrackerPage
